




































































































































































































































































































































































































































































































































































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import ManualOrder from '@/components/order/mixins/ManualOrder';

import {Component, Mixins, Watch} from 'vue-property-decorator';

@Component({
  components: {CompSelectBox, PageTitle}
})
export default class OrderManualOrder extends Mixins(ManualOrder) {
  @Watch('choseReceiverNameNo', {immediate: false, deep: false})
  choseReceiverNameNoChange(next: any): void {
    this.receiverInfoContent.map((item: any, index: number): any => {
      if (item.addressNo === next) {
        this.choseReceiverindex = index;
        this.formatterContact(item);
      }
    });
    this.calculateAmount();
  }
  @Watch('typeAddress')
  typeAddressChange(next: any): void {
    if (next === 'new') {
      this.receiverNameTap = false;
      this.choseReceiverindex = 0;
      this.initNewAddress();
    } else {
      this.getRecentAddress();
    }
  }
  @Watch('removeAllCheckbox')
  removeAllCheckboxChange(next: any): void {
    if (this.productListContent.length) {
      if (next) {
        this.productListContent.map((item: any): any => {
          item.check = true;
          if (item.firstLine) {
            item.checkAll = true;
          }
        });
      } else {
        const checks: any = this.productListContent.filter((item: any): any => {
          return item.check;
        });
        if (checks.length === this.productListContent.length) {
          this.productListContent.map((item: any): any => {
            item.check = false;
            if (item.firstLine) {
              item.checkAll = false;
            }
          });
        }
      }
    }
  }
  @Watch('productListContent.length')
  checkTheContent(next: any): void {
    if (!next) {
      this.emptyFlag = true;
    }
  }

  private created(): void {
    this.getTheMalls();
  }
  private mounted(): void {
    this.setWindowFn();
  }
  private destroyed(): void {
    this.theDestroyedInit();
  }
  private handleMallNoChange(): any {
    if (confirm(this.$t('ORDER_MANUAL_ORDER_CONFIRM_1') as any)) {
      this.initTopForm();
      this.getAccumulationInfo();
      this.beforeMallNo = this.selectMall.mallNo;
    } else {
      this.$nextTick((): any => {
        this.selectMall.mallNo = this.beforeMallNo;
      });
      return false;
    }
  }

  private handleFreeGiftChecked({ item, groupItem }): void {
    const checkedCount = groupItem.freeGifts.filter((freeGift) => freeGift.checked).length;
    
    if(groupItem.freeGiftOptionCount < checkedCount) {
      alert(`사은품은 최대 ${groupItem.freeGiftOptionCount}개까지 지급 받을 수 있습니다.`);
      
      // $nextTick을 사용해서 DOM 업데이트 후 상태 되돌리기
      this.$nextTick(() => {
        item.checked = false;
      });
      return;
    }
  }
}
